<template>
<div class="search-body">
  <div class="search-con">
    <div class="search-ban" :style="{marginLeft:(split-260)+ 'px'}">
      <div class="search-txt" v-if="searchTxt!==''">
        <vcenter>
          <div class="sj-con">
            <span>{{total||0}}</span>
            <div class="sanjiao" v-show="scene.length"></div>
          </div>
        </vcenter>
      </div>
      <div class="search-input">
        <div class="input">
          <vcenter>
            <input autofocus @keyup.enter="enter" v-model="searchTxt" :placeholder="langSearch.placeholder" type="text">
          </vcenter>
        </div>
      </div>
    </div>
    <div class="search-btn">
      <div class="img-con" @click="enter">
        <img :src="`${$cdn}images/search.png`" alt="">
      </div>
    </div>
    </div>
    <Item :searchTxt='searchTxt' :data='scene' :split='split'/>
    <div class="page-con" v-if="total" :style="{paddingLeft:(split-260)+ 'px'}">
      <div class="page-body">
        <!-- <div class="page-title">页码</div> -->
          <div class="paging">
            <vcenter>
              <Paging :current="currentPage" @clickHandle="pageChange" :total="total" :equable="pageSize" />
            </vcenter>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Item from './item/'
import vcenter from '@/components/vcenter'
import Paging from '@/components/Paging'
import {mapState} from 'vuex'

export default {
  props: ['split'],
  components: {
    Item,
    vcenter,
    Paging
  },
  data () {
    return {
      total: 0,
      searchTxt: '',
      pageSize: 10,
      scene: [],
      currentPage: 1
    }
  },
  computed: {
    ...mapState({
      langSearch: state => state.language.home.search
    })
  },
  watch: {
    currentPage () {
      this.getData()
    },
    '$route.name': function () {
      this.$bus.$emit('hideSearch')
    },
    searchTxt (newVal) {
      if (newVal) {
        this.getData()
      } else {
        this.scene = []
        this.total = 0
      }
    }
  },
  // 方法集合
  methods: {
    pageChange (data) {
      this.currentPage = data
    },
    enter () {
      this.currentPage = 1
      this.getData()
    },
    async getData () {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        searchKey: this.searchTxt
      }
      let result = await this.$http({
        method: 'post',
        data: params,
        url: '/scene/search'
      })
      let data = result.data.data
      this.scene = data.list
      this.total = data.total
    }
  },
  created () {

  },
  mounted () {
    // document.addEventListener('click', (e) => {
    //   if (this.$refs.searchcon) {
    //     if (!this.$refs.searchcon.contains(e.target)) {
    //       this.$bus.$emit('hideSearch', e.target)
    //     }
    //   }
    // })
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>



// WEBPACK FOOTER //
// src/page/navs/search/index.vue